export const onlyPhoneDigits = (value) => String(value ?? '').replace(/\D/g, '');

export const validateCardPhone = (value, country = 'Brasil') => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  const digits = onlyPhoneDigits(raw);
  if (!digits || /^(\d)\1+$/.test(digits)) {
    return 'Informe um telefone real. Sequências repetidas, como 000000000, não são aceitas.';
  }

  if (country === 'Brasil' && !/^\d{10,11}$/.test(digits)) {
    return 'Informe o telefone com DDD e 10 ou 11 dígitos.';
  }

  if (country !== 'Brasil' && (digits.length < 8 || digits.length > 15)) {
    return 'Informe um telefone válido, com 8 a 15 dígitos.';
  }

  return '';
};
